import { useState, useEffect } from "react";
import { http } from "../utils";
import { loginAdmin } from "../api/auth/login";
import { createContext } from "../utils/create-context";
import * as sessionService from "../utils/session";

const AUTH_SESSION_EXPIRED = "auth:sessionExpired";

const [useAuth, AuthInternalProvider] = createContext({
  name: "Auth",
});

export { useAuth };

export function AuthProvider(props) {
  const [accessToken, setAccessToken] = useState(() =>
    sessionService.getSession(sessionService.ACCESS_TOKEN_KEY)
  );

  useEffect(() => {
    const onSessionExpired = () => {
      sessionService.flushSession();
      setAccessToken(null);
    };
    window.addEventListener(AUTH_SESSION_EXPIRED, onSessionExpired);
    return () =>
      window.removeEventListener(AUTH_SESSION_EXPIRED, onSessionExpired);
  }, []);

  async function login(formField) {
    const { data } = await loginAdmin(formField);
    sessionService.setSession(
      sessionService.ACCESS_TOKEN_KEY,
      data?.data?.accessToken
    );
    sessionService.setSession(
      sessionService.REFRESH_TOKEN_KEY,
      data?.data?.refreshToken
    );
    setAccessToken(data?.data?.accessToken);
    return data;
  }

  async function logout() {
    await http("/auth/logout/admin", {
      data: {
        refreshToken: sessionService.getSession(
          sessionService.REFRESH_TOKEN_KEY
        ),
      },
    });
    sessionService.flushSession();
    setAccessToken(null);
  }

  return (
    <AuthInternalProvider
      value={{
        isAuth: !!accessToken,
        login,
        logout,
      }}
    >
      {props.children}
    </AuthInternalProvider>
  );
}
